module.exports = __webpack_public_path__ + "static/media/oyo.72c3d04a.jpeg";